import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=09a636ab&scoped=true&"
var script = {}
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=09a636ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a636ab",
  null
  
)

export default component.exports